/** Шкала «Исход» вычисляется только здесь; последнее правило без условия — пустого исхода не бывает */

import { MmMonitoringResult } from '../types/domain';
import { MmOutcome, MmTaskType } from '../types/enums';

function hasRawFlags(result: MmMonitoringResult): boolean {
  return (
    result.wasProductSkipped !== null && result.wasProductSkipped !== undefined
    || result.wasProductNotFound !== null && result.wasProductNotFound !== undefined
    || result.wasPriceNotRecognized !== null && result.wasPriceNotRecognized !== undefined
    || result.isSuccessful !== null && result.isSuccessful !== undefined
    /** Значим только false: true — информационный признак и в исход не входит */
    || result.wasProductRecognized === false
  );
}

export function resolveOutcome(
  result: MmMonitoringResult | null,
  taskType: MmTaskType | null,
): string {
  /** У Сплошного плана нет: отсутствие результата даёт терминальный исход, а не «Не выполнено» */
  if (result === null || result === undefined) {
    return taskType === MmTaskType.CONTINUOUS ? MmOutcome.UNSPECIFIED : MmOutcome.NOT_DONE;
  }

  if (hasRawFlags(result)) {
    if (result.wasProductSkipped === true) {
      return MmOutcome.SKIPPED;
    }

    if (result.wasProductNotFound === true) {
      return MmOutcome.PRODUCT_NOT_FOUND;
    }

    if (taskType === MmTaskType.KVI && result.wasProductRecognized === false) {
      return MmOutcome.ANALOG_COMPARE_FAILED;
    }

    if (result.wasPriceNotRecognized === true) {
      return MmOutcome.PRICE_NOT_RECOGNIZED;
    }

    if (result.isSuccessful === true) {
      return MmOutcome.PRICE_CAPTURED;
    }

    return MmOutcome.UNSPECIFIED;
  }

  /** Незнакомый код исхода не подменяем: перечень исходов открыт, подмена потеряла бы данные */
  const raw = result.outcome === null || result.outcome === undefined
    ? ''
    : String(result.outcome).trim();

  if (raw === '') {
    return MmOutcome.UNSPECIFIED;
  }

  return raw.toLowerCase() === 'other' ? 'other' : raw;
}

export function isOutcomeUnspecified(
  result: MmMonitoringResult | null,
  taskType: MmTaskType | null,
): boolean {
  return resolveOutcome(result, taskType) === MmOutcome.UNSPECIFIED;
}

/** Неизвестную причину возвращаем как есть: словарь причин не закрыт, прочерк потерял бы данные */
export function normalizeSkipReason(skipReason: string | null): string {
  if (skipReason === null || skipReason === undefined) {
    return '';
  }

  const trimmed = String(skipReason).trim();

  if (trimmed === '') {
    return '';
  }

  return trimmed.toLowerCase();
}
